import React, { Component, Fragment } from 'react';
import { connect, useSelector } from 'react-redux';
import classnames from 'classnames';
import RichEditor from './rich/RichEditor';
import HtmlEditor from './html/HtmlEditor';
import MarkdownEditor from './markdown/MarkdownEditor';
import PostTags from './PostTags';
import { EDITOR_MODE_HTML, EDITOR_MODE_MARKDOWN, EDITOR_MODE_RICH } from '../../constants/EditorMode';

function Editor ({ editorMode }) {
  switch (parseInt(editorMode)) {
    case EDITOR_MODE_HTML:
      return <HtmlEditor />;
    case EDITOR_MODE_MARKDOWN:
      return <MarkdownEditor />;
    case EDITOR_MODE_RICH:
    default:
      return <RichEditor />;
  }
}

export default function () {
  const editorMode = useSelector(state => state.env.editorMode);
  const footerVisible = useSelector(state => state.env.footerVisible);

  return (
    <div role={'main'} id={'editorContainer'} className={classnames('content-editor keditor', {
      editor_type2: editorMode === EDITOR_MODE_HTML,
      'no-footer': !footerVisible,
    })}>
      <Editor editorMode={editorMode} />
      <PostTags />
    </div>
  );
}
